import React, { useState, useCallback } from 'react'
import Button from 'react-bootstrap/Button'
import Form from 'react-bootstrap/Form'
import Modal from 'react-bootstrap/Modal'
import Alert from 'react-bootstrap/Alert'
import AnimateHeight from 'react-animate-height'
import FontAwesome from 'react-fontawesome'
import I18n from '../../../resources/i18n/I18n'
import './ModalImportCsv.scss'

const ModalImportCsv = ({ showModal, toggleModal, importCsv, onFileChange, type }) => {
  const [file, setFile] = useState(null)
  const [isInstructionsOpen, setIsInstructionsOpen] = useState(false)

  const handleClose = useCallback(() => {
    toggleModal()
    setFile(null)
    setIsInstructionsOpen(false)
  }, [toggleModal])

  const handleDryRun = useCallback(() => {
    importCsv(file, true)
    handleClose()
  }, [file, importCsv, handleClose])

  const handleFileChange = useCallback(
    (e) => {
      const selectedFile = e.target?.files?.[0] || null
      setFile(selectedFile)
      onFileChange?.()
    },
    [onFileChange],
  )

  const toggleInstructions = useCallback(() => {
    setIsInstructionsOpen((prev) => !prev)
  }, [])

  const formatFileSize = (bytes) => Math.round(bytes / 1024)

  return (
    <Modal show={showModal} onHide={handleClose} className="modal-import-csv">
      <Modal.Header closeButton>
        <Modal.Title>
          <strong>{type === 'userRelations' ? I18n.t('ImportTeamsTitle') : I18n.t('ImportPatrimonyTitle')}</strong>
        </Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <div className="mb-4">
          <div className="w-100 instructions__container">
            <div
              className={`d-flex justify-content-between align-items-center instructions__header ${
                isInstructionsOpen ? 'instructions__header--expanded' : ''
              }`}
              onClick={toggleInstructions}
            >
              <span className="instructions__header-title">{I18n.t('ImportInstructionsTitle')}</span>
              <FontAwesome name={isInstructionsOpen ? 'chevron-up' : 'chevron-down'} />
            </div>

            <AnimateHeight duration={200} height={isInstructionsOpen ? 'auto' : 0}>
              <div className="instructions__content">
                <div className="mb-4">
                  <strong className="instructions__section-title">{I18n.t('ImportModulesTitle')}</strong>
                  <ul className="instructions__list">
                    <li>
                      <strong>{I18n.t('ImportDryRunLabel')} :</strong> {I18n.t('ImportDryRunDescription')}
                    </li>
                    <li>
                      <strong>{I18n.t('ImportRealLabel')} :</strong> {I18n.t('ImportRealDescription')}
                    </li>
                  </ul>
                </div>

                <div className="mb-4">
                  <strong className="instructions__section-title">{I18n.t('ImportFileFormatTitle')}</strong>
                  <ul className="instructions__list">
                    <li>{I18n.t('ImportFileFormatCSV')}</li>
                    <li>{I18n.t('ImportFileFormatEncoding')}</li>
                  </ul>
                </div>

                <div className="mb-4">
                  <strong className="instructions__section-title">{I18n.t('ImportRequiredColumnsTitle')}</strong>
                  <ul className="instructions__list">
                    <li>{I18n.t('ImportRequiredColumnPatrimony')}</li>
                    <li>{I18n.t('ImportRequiredColumnSector')}</li>
                    <li>{I18n.t('ImportRequiredColumnAgency')}</li>
                  </ul>
                </div>

                <div>
                  <strong className="instructions__section-title">{I18n.t('ImportOptionalColumnsTitle')}</strong>
                  <ul className="instructions__list">
                    <li>{I18n.t('ImportOptionalColumnManagerEmail')}</li>
                    <li>{I18n.t('ImportOptionalColumnGuardianEmail')}</li>
                  </ul>
                </div>
              </div>
            </AnimateHeight>
          </div>
        </div>

        <div className="upload-zone">
          <Form.Group>
            <Form.Label className="file-upload__label">{I18n.t('ImportSelectFileLabel')}</Form.Label>
            <Form.Control type="file" accept=".csv" onChange={handleFileChange} className="mb-3 file-upload__input" />
            {file && (
              <Alert className="small file-upload__alert">
                <div className="d-flex align-items-center">
                  <div className="flex-grow-1" style={{ minWidth: 0 }}>
                    <span>{I18n.t('ImportFileSelected')} </span>
                    <strong className="file-upload__file-name">{file.name}</strong>
                    <span className="ml-2 file-upload__file-size">({formatFileSize(file.size)} Ko)</span>
                  </div>
                </div>
              </Alert>
            )}
          </Form.Group>
        </div>
      </Modal.Body>

      <Modal.Footer>
        <Button variant="secondary" className="footer__cancel-btn" onClick={handleClose}>
          {I18n.t('ModalConfirmCancel')}
        </Button>
        <Button className="primary" onClick={handleDryRun} disabled={!file}>
          {I18n.t('ImportDryRunButton')}
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

export default ModalImportCsv
